<template>
  <t-modal
    v-model="isVisible"
    @closed="onModalClosed"
    name="edit-banner-modal"
  >
    <h2 class="mb-3">Storefront Cover Image</h2>
    <ImageCropper
      v-if="editing"
      :imagePath="selectedBanner.path"
      :aspectWidth="4"
      :aspectHeight="1"
      :width="1024"
      :height="256"
      :resizable="false"
      v-on:onApplyChanges="handleApplyChanges"
      v-on:onCancelEdit="handleCancelEdit"
    />

    <div v-if="!editing">
      <div class="flex relative mb-2 h-20">
        <button
          class="w-full bg-center bg-cover br-10"
          :style="{backgroundImage: 'url(' + selectedBanner.path + ')'}"
          type="button"
          @click="onEditImage"
          title="Edit banner image"
        ></button>
      </div>
      <div class="flex items-center justify-between mb-5">
        <MediaUploadButton
          v-on:onFileUpload="onUploadMedia"
          text="Upload an Image"
        />
        <button
          class="primary-btn"
          type="button"
          @click.prevent="onSave"
        >Save Changes</button>
      </div>
      <div class="border border-l border-salesium-grey-100 mb-5"></div>
      <div>
        <button
          @click="toggleAccordion()"
          class="flex items-center justify-between space-x-3 w-full mb-5"
          :aria-expanded="isOpen"
          :aria-controls="`collapse${_uid}`"
          :title="accordionButtonTitle"
        >
          Select a Preset Image
          <svg-vue
            icon="angle-up-solid"
            class="w-6 h-6 transition-all duration-200 transform fill-salesium-red"
            :class="{'rotate-90': !isOpen, 'rotate-180': isOpen}"
          />
        </button>
        <div
          v-show="isOpen"
          :id="`collapse${_uid}`"
          class="flex flex-wrap justify-between"
        >
          <PresetBanner
            v-for="(banner, id) in presetBanners"
            :banner="banner"
            :key="id"
            v-on:onToggle="toggleSelectedBanner"
            :selected="selectedBannerId === id"
            :id="id"
          />
        </div>
      </div>
    </div>

  </t-modal>
</template>

<script>
import MediaUploadButton from '../../Utils/MediaUploadButton.vue';
import PresetBanner from './PresetBanner.vue';
import { presetBanners } from '../../../constants/presetBanners';
import ImageCropper from '../../Utils/ImageCropper.vue';
export default {
    // TODO: pass in background image to use
    // TODO: pre-select the last selected preset banner
    props: ['modalVisible'],
    data() {
        return {
            isVisible: this.modalVisible,
            defaultBannerImage: '/images/example-banner.png',
            isOpen: false,
            presetBanners: presetBanners,
            selectedBannerId: 1,
            selectedBanner: {
                title: 'Default banner',
                path: '/images/large-test.jpeg',
            },
            editing: false,
        };
    },
    watch: {
        modalVisible() {
            if (this.isVisible !== this.modalVisible) {
                this.isVisible = this.modalVisible;
            }
        },
        selectedBannerId() {
            if (this.selectedBannerId) {
                this.selectedBanner = this.presetBanners[this.selectedBannerId];
            } else {
                this.selectedBanner = {
                    title: 'Default',
                    path: '/images/example-banner.png',
                };
            }
        },
    },
    methods: {
        onModalClosed() {
            this.$emit('modalHidden');
            this.editing = false;
        },
        onUploadMedia(event) {
          // TODO: open way to upload media
          const file = event.target.files[0];
        },
        onSave() {
            // TODO: add functionality of saving media
            this.isOpen = false;
            this.isVisible = false;
            this.$emit('bannerSelected', this.selectedBanner);
        },
        toggleAccordion() {
            this.isOpen = !this.isOpen;
        },
        toggleSelectedBanner(bannerId) {
            if (this.selectedBannerId === bannerId) {
                this.selectedBannerId = null;
            } else {
                this.selectedBannerId = bannerId;
            }
        },
        onEditImage() {
            this.editing = true;
        },
        handleApplyChanges(event) {
            // TODO: apply editing changes to image
            this.editing = false;
        },
        handleCancelEdit() {
            this.editing = false;
        },
    },
    computed: {
        accordionButtonTitle() {
            return this.isOpen ? 'Hide preset images' : 'Show preset images';
        },
    },
    components: {
        MediaUploadButton,
        PresetBanner,
        ImageCropper,
    },
};
</script>

<style scoped>
.cropper {
    width: 1024px;
}
</style>
